import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

class ToggleMode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: props.defaultSelected || props.toggleOptions[0],
      componentID: (new Date()).getTime()
    };

    this._onChange = this._onChange.bind(this);
  }

  componentDidUpdate() {
    if (this.state.mode !== this.props.defaultSelected) {
      this.setState({ mode: this.props.defaultSelected });
    }
  }

  render() {
    var inputs = [];

    this.props.toggleOptions.forEach(function(toggleName) {
      var domID = this.state.componentID + "_" + toggleName;
      inputs.push(
        <input
          id={domID}
          key={domID + "_input"}
          name={"mode_" + this.state.componentID} type="radio"
          value={toggleName}
          onChange={this._onChange}
          checked={this.state.mode === toggleName} />
      );
      inputs.push(<label key={domID + "_label"} htmlFor={domID}>{toggleName}</label>);
    }.bind(this));

    return (
      <div
        className={ ClassNames("switch-toggle well right", { disabled: this.props.disabled }) }
        style={{ width: '200px' }}>
        { inputs }
        <a className="btn btn-default"></a>
      </div>
    );
  }

  _onChange(evt) {
    evt.target.blur();

    this.setState({ mode: evt.target.value });
    this.props.onToggle(evt.target.value);
  }
}

ToggleMode.propTypes = {
  onToggle: PropTypes.func.isRequired,
  toggleOptions: PropTypes.array.isRequired,
  defaultSelected: PropTypes.string,
  disabled: PropTypes.bool
};

export default ToggleMode;
